<template>
  <span>
    <span v-if="typeof customer !== 'undefined'">
      <span v-if="!present">
        <span v-if="customer.contacts.filter(contact => contact.name && contact.name.trim() !== '').map(contact => contact.name).join('').trim() !== ''">
          <el-tooltip placement="right" :content="customer.contacts.filter(contact => contact.name && contact.name.trim() !== '').map(contact => contact.name).join(', ')">
            <router-link :to="'/customers/' + customer.id">
              <customer :item="customer" present="icon"></customer>
              {{ customer.name }} ({{ customer.address.zip_code }})
            </router-link>
          </el-tooltip>
          <customer :item="customer" present="badges"></customer>
        </span>
        <span v-else>
          <router-link :to="'/customers/' + customer.id">
            <customer :item="customer" present="icon"></customer>
            {{ customer.name }} ({{ customer.address.zip_code }})
            <customer :item="customer" present="badges"></customer>
          </router-link>
        </span>
      </span>

      <span v-if="present === 'minimal'">
        <router-link :to="'/customers/' + customer.id">
          <customer :item="customer" present="icon"></customer>
        </router-link>
      </span>

      <span v-if="present === 'icon'">
        <i class="fa fa-building" title="Marchand de biens" v-if="customer.job_type === 'Marchand de biens'"></i>
        <i class="fa fa-home" title="Métier de la construction" v-if="customer.job_type === 'Métier de la construction'"></i>
        <i class="fa fa-wrench" title="Travaux et rénovation" v-if="customer.job_type === 'Travaux et rénovation'"></i>
      </span>

      <span v-if="present === 'option'">
        <el-option
          :label="customer.name + ' (' + customer.address.zip_code  + ')'"
          :value="customer.id">
          <span
            :style="{float: 'left'}"
            :class="{'text-muted': !isOurCustomer()}"
          >
            {{ customer.name + ' (' + customer.address.zip_code + ')' }}

            <customer :item="customer" present="badges"></customer>
          </span>

          <span style="float: right;">
            <customer :item="customer" present="sources"></customer>
          </span>
        </el-option>
      </span>

      <span v-if="present === 'badges'">
        <span style="color: #bbb;">
          <i v-if="customer.services.length > 0" title="Services" class="fa fa-paper-plane"></i>
          <i v-if="hasSourceField('comments')" title="Commentaires" class="fa fa-comment"></i>
          <i v-if="customer.contacts.length > 0" title="Contacts" class="fa fa-address-card"></i>
          <i v-if="isOurCustomer()" title="Dans mon parc" class="fa fa-handshake-o"></i>
        </span>
      </span>

      <span v-if="present === 'sources'">
        <span style="color: #8492a6; font-size: 0.8em">
            <span v-if="customer.sources['devis-b2b']">
              <source-app name="devis-b2b" size="tiny"></source-app>
            </span>
            <span v-if="customer.sources['sellsy-comweb']">
              <source-app name="sellsy-comweb" size="tiny"></source-app>
            </span>
          </span>
      </span>

      <span v-if="present === 'name'">
        {{ customer.name }}
        <span v-if="customer.public.name">
          ({{ customer.public.name }})
        </span>
      </span>

      <span v-if="present === 'job'">
        <customer :item="customer" present="icon"></customer> {{ customer.job_type }}
        <span v-if="customer.job">({{ customer.job }})</span>
      </span>

      <span v-if="present === 'city'">
        <i class="fa fa-map-marker text-muted"></i> {{ customer.address.city }} ({{ customer.address.zip_code }})
      </span>

      <span v-if="present === 'first_phone'">
        <i class="fa fa-phone text-muted"></i> {{ customer.contact_details.first_phone }}
      </span>

      <span v-if="present === 'second_phone'">
        <i class="fa fa-phone text-muted"></i> {{ customer.contact_details.second_phone }}
      </span>

      <span v-if="present === 'email'">
        <i class="fa fa-envelope-o text-muted"></i>
        <a :href="'mailto:'+customer.contact_details.email">{{ customer.contact_details.email }}</a>
      </span>

      <span v-if="present === 'website'">
        <i class="fa fa-link text-muted"></i> <a :href="customer.contact_details.website">Site internet</a>
      </span>

      <span v-if="present === 'remarks'">
        <i class="fa fa-commenting text-muted"></i> infos importantes:
        <span v-if="customer.contact_details.remarks">
          {{ customer.contact_details.remarks }}
        </span>
        <span v-else>
          /
        </span>
      </span>

      <span v-if="present === 'contacts'">
        <ul class="ul-fa">
          <li v-for="contact in customer.contacts" :key="contact.id" style="padding: 0">
            <el-popover placement="right" width="300" trigger="hover" :title="contact.name">
              <div>
                <div>Téléphone 1 : {{ contact.first_phone }}</div>
                <div>Téléphone 2 : {{ contact.second_phone }}</div>
                <div>Email : {{ contact.email }}</div>
              </div>
              <span slot="reference">
                <source-app :name="contact.source" size="tiny"></source-app>
                {{ contact.name }}
              </span>
            </el-popover>
          </li>
        </ul>
      </span>

      <span v-if="present === 'services'">
        <ul class="ul-fa">
          <li v-for="service in customer.services" v-if="typeof(service.end_at) === 'undefined' || moment(service.end_at.date).isAfter(moment())" :key="service.id">
            <source-app :name="service.source" size="tiny"></source-app> {{ service.name }}
            <span v-if="typeof(service.end_at) !== 'undefined' && moment(service.end_at.date).diff(moment(), 'days') < 30">
              <el-tooltip content="Le service expire dans moins d'un mois" placement="top">
                <i class="fa fa-exclamation-triangle text-danger"></i>
              </el-tooltip>
            </span>
            <span v-else-if="typeof(service.end_at) !== 'undefined' && moment(service.end_at.date).diff(moment(), 'days') < 60">
              <el-tooltip content="Le service expire dans moins de deux mois" placement="top">
                <i class="fa fa-exclamation-triangle text-warning"></i>
              </el-tooltip>
            </span>
          </li>
        </ul>
      </span>

      <span v-if="present === 'analyze'">
        <span v-if="customer.meta && customer.meta.commercial && customer.meta.commercial.statistics">
          Du {{ moment(customer.meta.commercial.statistics.range.from).format('DD/MM/YYYY') }}
          au {{ moment(customer.meta.commercial.statistics.range.to).format('DD/MM/YYYY') }} :
          <ul>
            <li v-if="customer.meta.commercial.statistics.prices.quotes_lt" :class="[customer.meta.commercial.statistics.prices.quotes_lt > 15 ? 'text-danger' : 'text-success']">
              {{ customer.meta.commercial.statistics.prices.quotes_lt }} € / Lead LT
            </li>
            <li v-if="customer.meta.commercial.statistics.prices.ads_cpc" :class="[customer.meta.commercial.statistics.prices.ads_cpc > 2 ? 'text-danger' : 'text-success']">
              Pubs {{ customer.meta.commercial.statistics.prices.ads_cpc }} € CPC ({{ customer.meta.commercial.statistics.prices.ads_cpm }} € CPM)
            </li>
            <li v-if="customer.meta.commercial.statistics.prices.grounds_email" :class="[customer.meta.commercial.statistics.prices.grounds_email > 18 ? 'text-danger' : 'text-success']">
              {{ customer.meta.commercial.statistics.prices.grounds_email }} € / Email Annonce
            </li>
          </ul>
        </span>
        <span v-else>
          Aucune analyse.
        </span>
      </span>
    </span>
    <span v-else>
      <pulse-loader color="#cccccc" size="8px"></pulse-loader>
    </span>
  </span>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import SourceApp from './SourceApp.vue'
  import Document from './Document.vue'
  import TimelineCallWidget from "../Widgets/Customers/Summary/Timeline/TimelineCallWidget.vue"


  export default {
    name: 'customer',
    components: {
      Document,
      SourceApp,
      PulseLoader,
      TimelineCallWidget
    },
    data () {
      return {
        last_call : undefined
      }
    },
    props: ['present', 'item'],
    computed: {
      customer () {
        return this.item
      }
    },
    methods: {
      hasSourceField (name) {
        for (let source in this.customer.source_fields) {
          if (this.customer.source_fields[source][name] && this.customer.source_fields[source][name].length > 0) {
            return true
          }
        }

        return false
      },
      isOurCustomer () {
        return this.customer.user_id === this.$store.getters['users/current'].id
      },
    }
  }
</script>



// WEBPACK FOOTER //
// Customer.vue?20a0ab1c